<template>
  <van-popup v-model="show" :close-on-click-overlay="false" style="z-index: 999999;">
    <div class="popup_box">

      <div class="close-btn" v-if="isShowCloseBtn" @click="onClose">
        <van-icon name="cross" />
      </div>
      <div class="popup_text">
        <div class="popup_text_title">
          {{ title }}
        </div>
        <slot name="center">
          <div class="text">
            {{ text }}
          </div>
        </slot>

        <div class="popup_btn_box" v-if="isShowBtn">
          <div class="popup_btn_box_rit" @click="onClose">
            {{ closeText }}
          </div>
          <div class="popup_btn_box_lef" @click="onSuccess">
            {{ onText }}
          </div>
        </div>
      </div>
      <div class="bottomClose" @click="onClose">
        <img src="@/assets/image/icon/tcclose.png" alt="关闭" />
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    onText: {
      type: String,
      default: '确定'
    },
    closeText: {
      type: String,
      default: '取消'
    },
    title: {
      type: String,
      default: '温馨提醒'
    },
    text: {
      type: String,
      default: ''
    },
    isShowBtn: {
      type: Boolean,
      default: true
    },
    isShowCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
    onClose() {
      this.$emit('onClose')
    },
    // 继续
    onSuccess() {
      this.$emit('onSuccess')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep.van-popup {
  border-radius: .5rem;
}

.popup_box {
  width: 15.5rem;
  padding: 0 .7rem;
  color: #656565;
  border-radius: .5rem;
  border: .05rem solid #eee6e6;
  background: linear-gradient(180deg, #fff3d4 0%, #ffffff 40%);
  box-sizing: border-box;
  position: relative;

  .close-btn {
    position: absolute;
    right: 0.7rem;
    top: 0.7rem;
    cursor: pointer;
    font-size: 20px;
    color: #333;
  }

  .popup_text {
    margin-top: 1rem;
    text-align: center;
    font-size: 1rem;
  }

  .popup_text_title {
    margin-bottom: .9rem;
    font-size: 1rem;
    font-weight: bold;
    color: black;
  }

  .text {
    font-size: .7rem;
    color: #1d1d1d;
    margin-bottom: 1rem;
    line-height: 1.2rem;
    text-align: center;
  }

  .popup_btn_box {
    display: flex;
    justify-content: center;
    margin-bottom: 1.4rem;
    box-sizing: border-box;
    font-size: .7rem;

    .popup_btn_box_lef {
      width: 5.9rem;
      height: 1.7rem;
      line-height: 1.7rem;
      text-align: center;
      border-radius: .85rem;
      color: #ffdb89;
      background: linear-gradient(90deg, #1D1D1D 0%, #5B4E3F 100%);
      margin-left: 1.5rem;
      box-sizing: border-box;
    }

    .popup_btn_box_rit {
      width: 5.9rem;
      height: 1.7rem;
      line-height: 1.7rem;
      text-align: center;
      color: #8e8e8e;
      border-radius: .85rem;
      border: .05rem solid #8e8e8e;
      opacity: 1;
      box-sizing: border-box;
    }
  }

  .bottomClose {
    position: absolute;
    bottom: -2.5rem;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;

    img {
      width: .93rem;
      height: .93rem;
    }
  }

}
</style>